export enum EWidgetThemes {
  RED = 'red',
  ORANGE = 'orange',
  YELLOW = 'yellow',
  GREEN = 'green',
  AQUAMARINE = 'aquamarine',
  BLUE = 'blue',
  PURPLE = 'purple',
  PINK = 'pink',
  BLACK = 'black'
}

export interface IWidgetTheme {
  primaryColor: string;
  primaryColorDarken: string;
  primaryGradient: string;
  darkTextColor: string;
  primaryGradientTextColor?: string;
  blurGradient?: string;
  backgroundGradient2Hover: string;
  background: string;
  colorLight: string;
  backgroundLight: string;
  backgroundCarousel?: string;
  slightGradient: string;
  iconBackground: string;
  dotSlide: string;
}

export const WidgetThemesDictionary: Record<EWidgetThemes, IWidgetTheme> = {
  [EWidgetThemes.RED]: {
    primaryColor: '#EB3B47',
    primaryColorDarken: '#A1272E',
    darkTextColor: '#3D3D3D',
    primaryGradient:
      'linear-gradient(263.71deg, #EB3B47 5.13%, #D0333D 96.77%)',
    blurGradient:
      'linear-gradient(180deg, rgba(253, 231, 233, 0.7) 0%, rgba(253, 231, 233, 0) 76.15%)',
    backgroundGradient2Hover:
      'linear-gradient(263.71deg, #CF333E 5.13%, #A31B25 96.77%)',
    background: '#691A2B',
    backgroundLight: '#FFFCFD',
    colorLight: '#C0094E',
    slightGradient:
      'linear-gradient(180deg, rgba(253, 231, 233, 0.7) 0%, rgba(253, 231, 233, 0) 76.15%)',
    iconBackground:
      'linear-gradient(180deg, #FBE4E4 0%, rgba(251, 228, 228, 0) 100%)',
    dotSlide: '#DBD5D8'
  },
  [EWidgetThemes.ORANGE]: {
    primaryColor: '#EE7503',
    primaryColorDarken: '#C95D0F',
    darkTextColor: '#3D3D3D',
    primaryGradient:
      'linear-gradient(263.71deg, #FF981E 5.13%, #EC7100 96.77%)',
    blurGradient:
      'linear-gradient(180deg, rgba(255, 224, 188, 0.6) 0%, rgba(255, 224, 188, 0) 76.15%)',
    backgroundGradient2Hover:
      'linear-gradient(263.71deg, #EE8100 5.13%, #C05C00 96.77%)',
    background: '#5C2E03',
    backgroundLight: '#FFFCFA',
    colorLight: '#FF8A00',
    slightGradient:
      'linear-gradient(180deg, rgba(255, 224, 188, 0.6) 0%, rgba(255, 224, 188, 0) 76.15%)',
    iconBackground:
      'linear-gradient(180deg, #F9EADA 0%, rgba(249, 234, 218, 0) 100%)',
    dotSlide: '#E2DCD7'
  },
  [EWidgetThemes.YELLOW]: {
    primaryColor: '#F5AB01',
    primaryColorDarken: '#B27A01',
    darkTextColor: '#3D3D3D',
    primaryGradient:
      'linear-gradient(263.71deg, #FCCD03 5.13%, #F4A700 96.77%)',
    primaryGradientTextColor: '#6A4C02',
    blurGradient:
      'linear-gradient(180deg, rgba(252, 234, 157, 0.4) 0%, rgba(255, 237, 162, 0) 76.15%)',
    backgroundGradient2Hover:
      'linear-gradient(263.71deg, #E9B500 5.13%, #C78800 96.77%)',
    background: '#653F02',
    backgroundLight: '#FFFCF7',
    colorLight: '#FFC33E',
    slightGradient:
      'linear-gradient(180deg, rgba(252, 234, 157, 0.4) 0%, rgba(255, 237, 162, 0) 76.15%)',
    iconBackground:
      'linear-gradient(180deg, #F7EFCF 0%, rgba(247, 239, 207, 0) 100%)',
    dotSlide: '#DBD4C8'
  },
  [EWidgetThemes.GREEN]: {
    primaryColor: '#19A862',
    primaryColorDarken: '#137B49',
    darkTextColor: '#3D3D3D',
    primaryGradient:
      'linear-gradient(263.71deg, #22CF67 5.13%, #18A561 96.77%)',
    blurGradient:
      'linear-gradient(180deg, #D4F8E3 0%, rgba(212, 248, 227, 0) 76.15%)',
    backgroundGradient2Hover:
      'linear-gradient(263.71deg, #127841 5.13%, #0C502C 96.77%)',
    background: '#044132',
    backgroundLight: '#FCFFFD',
    colorLight: '#05AA81',
    slightGradient:
      'linear-gradient(180deg, #D4F8E3 0%, rgba(212, 248, 227, 0) 76.15%)',
    iconBackground:
      'linear-gradient(180deg, #D9EEE4 0%, rgba(217, 238, 228, 0) 100%)',
    dotSlide: '#C8DBD0'
  },
  [EWidgetThemes.AQUAMARINE]: {
    primaryColor: '#07A7AC',
    primaryColorDarken: '#067E82',
    darkTextColor: '#343D3C',
    primaryGradient:
      'linear-gradient(263.71deg, #10CBD1 5.13%, #06A5AA 96.77%)',
    blurGradient:
      'linear-gradient(180deg, #DEF5F6 0%, rgba(222, 245, 246, 0) 76.15%)',
    backgroundGradient2Hover:
      'linear-gradient(263.71deg, #088D91 5.13%, #056366 96.77%)',
    background: '#034345',
    backgroundLight: '#FAFFFF',
    colorLight: '#0ABFC5',
    slightGradient:
      'linear-gradient(180deg, #DEF5F6 0%, rgba(222, 245, 246, 0) 76.15%)',
    iconBackground:
      'linear-gradient(180deg, #D2EDEF 0%, rgba(210, 237, 239, 0) 100%)',
    dotSlide: '#C6D8D8'
  },
  [EWidgetThemes.BLUE]: {
    primaryColor: '#168EF9',
    primaryColorDarken: '#1E95FF',
    darkTextColor: '#012A5A',
    primaryGradient:
      'linear-gradient(263.71deg, #1E95FF 5.13%, #007CEA 96.77%)',
    blurGradient:
      'linear-gradient(180deg, #E1F1FF -22.71%, rgba(210, 234, 255, 0) 76.15%)',
    backgroundGradient2Hover:
      'linear-gradient(263.71deg, #1085ED 5.13%, #0068C5 96.77%)',
    background: '#0B3874',
    backgroundLight: '#F7F9FF',
    colorLight: '#036FFF',
    slightGradient:
      'linear-gradient(180deg, #E1F1FF -22.71%, rgba(210, 234, 255, 0) 76.15%)',
    iconBackground: 'linear-gradient(180deg, #D9E9FF 0%, #FFFFFF 100%)',
    dotSlide: '#CDDAEB'
  },
  [EWidgetThemes.PURPLE]: {
    primaryColor: '#8812E5',
    primaryColorDarken: '#6408AC',
    darkTextColor: '#14003E',
    primaryGradient:
      'linear-gradient(263.71deg, #A532FF 5.13%, #850FE2 96.77%)',
    blurGradient:
      'linear-gradient(180deg, rgba(154, 92, 255, 0.2) 0%, rgba(154, 92, 255, 0) 76.15%)',
    backgroundGradient2Hover:
      'linear-gradient(263.71deg, #8A1AE2 5.13%, #6304AE 96.77%)',
    background: '#3B0763',
    backgroundLight: '#FDFAFF',
    colorLight: '#8C1EE2',
    slightGradient:
      'linear-gradient(180deg, rgba(154, 92, 255, 0.2) 0%, rgba(154, 92, 255, 0) 76.15%)',
    iconBackground:
      'linear-gradient(180deg, #E7E0FF 0%, rgba(231, 224, 255, 0) 100%)',
    dotSlide: '#E4C9DA'
  },
  [EWidgetThemes.PINK]: {
    primaryColor: '#DE0186',
    primaryColorDarken: '#9C0067',
    darkTextColor: '#3D3D3D',
    primaryGradient:
      'linear-gradient(263.71deg, #FA05A7 5.13%, #DC0084 96.77%)',
    blurGradient:
      'linear-gradient(180deg, rgba(250, 5, 152, 0.14) 0%, rgba(250, 5, 152, 0) 76.15%)',
    backgroundGradient2Hover:
      'linear-gradient(263.71deg, #D9008F 5.13%, #B5006C 96.77%)',
    background: '#680045',
    backgroundLight: '#FFFAFD',
    colorLight: '#E30096',
    slightGradient:
      'linear-gradient(180deg, rgba(250, 5, 152, 0.14) 0%, rgba(250, 5, 152, 0) 76.15%)',
    iconBackground:
      'linear-gradient(180deg, #FBE6F2 0%, rgba(251, 230, 242, 0) 100%)',
    dotSlide: '#E4C9DA'
  },
  [EWidgetThemes.BLACK]: {
    primaryColor: '#2C2F37',
    primaryColorDarken: '#2C2F37',
    darkTextColor: '#384357',
    primaryGradient:
      'linear-gradient(263.71deg, #4A4E56 5.13%, #2A2D35 96.77%)',
    blurGradient:
      'linear-gradient(180deg, rgba(75, 92, 112, 0.2) 0%, rgba(75, 92, 112, 0) 76.15%)',
    backgroundGradient2Hover:
      'linear-gradient(263.71deg, #34363D 5.13%, #0A0B0F 96.77%)',
    background: '#24262D',
    colorLight: '#767A89',
    backgroundLight: '#555964',
    backgroundCarousel: '#333640',
    slightGradient:
      'linear-gradient(180deg, rgba(75, 92, 112, 0.2) 0%, rgba(75, 92, 112, 0) 76.15%)',
    iconBackground:
      'linear-gradient(180deg, rgba(230, 241, 255, 0.16) 0%, rgba(255, 255, 255, 0) 100%)',
    dotSlide: '#383B43'
  }
};
